/**
 * description 融合编辑器模块
 * created by he.zhikai
 * created on 2017-12-26
 */
'use strict';
angular.module('editFusionEditorModule', [
    'editFusionEditorRouterModule', // 融合编辑器路由模块
    'editFusionEditorServiceModule', // 融合编辑器服务模块
    'editFusionNewsModule', // 融合编辑器新闻稿模块
    'editFusionAtlasModule', // 融合编辑器图集稿模块
    'editFusionLinkdocModule', // 融合编辑器链接稿模块
    'editFusionVideoModule', // 融合编辑器视频稿模块
    'editFusionLiveModule', // 融合编辑器直播稿模块
    'editFusionPreviewModule' // 融合编辑器详情页模块
]);
